import { Button, ContentBlock, Flex, Text } from '@volue/wave-react';
import React from 'react';

import { useActions } from '@/overmind';

export const SignInArcGisPage = () => {
  const { signInArcGis } = useActions().arcgis.identity;

  return (
    <Flex gap="spacingS" className="pAl jcC h100 w100">
      <ContentBlock max="measureWide">
        <Flex flow="column" cross="center" gap="spacingM" paddingY="spacingL">
          <Text css={{ fontSize: '$delta', textAlign: 'center' }}>
            <div>
              {
                'Grid Calculator requires that you log in with your ArcGIS account.'
              }
            </div>
          </Text>
          <Button onClick={async () => await signInArcGis()}>
            {'Log in to ArcGIS'}
          </Button>
        </Flex>
      </ContentBlock>
    </Flex>
  );
};
